import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase"; // adjust path to match your existing firebase.js

/**
 * Calls the createPaymentIntent Cloud Function.
 * @param {Object} params
 * @param {string} params.bookingId - Firestore doc id of the booking draft
 * @param {number} params.amount - amount in the SMALLEST currency unit (e.g. cents for SGD)
 * @param {string} [params.currency] - defaults to "sgd" (required for PayNow)
 * @param {string} [params.customerEmail]
 * @param {string} [params.customerName]
 * @returns {Promise<{ clientSecret: string }>}
 */
export async function createPaymentIntent({
  bookingId,
  amount,
  currency = "sgd",
  customerEmail,
  customerName,
}) {
  const callable = httpsCallable(functions, "createPaymentIntent");
  const result = await callable({
    bookingId,
    amount,
    currency,
    customerEmail,
    customerName,
  });
  return result.data; // { clientSecret }
}
